export default __webpack_public_path__ + "static/media/corretto.05a766c7.jpg";